import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, Suspense as _Suspense, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-py-md"
}

import { computed, nextTick, onBeforeMount, onMounted, onUnmounted, ref, watch } from 'vue'
import { RecapResponse } from '../../types/recap'
import { storeToRefs } from 'pinia'
import { useStoreRecaps } from '../../store/useStoreRecaps'
import RecapDefinition from '../../components/recaps/RecapDefinition.vue'
import { useStore } from '../../store'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreRecaps',
  props: {
    storeId: {}
  },
  setup(__props: any) {

onBeforeMount(async () => {
  //add store's recap definitions into memory
  await useStoreRecaps().setRecapsForStore(String(props.storeId))
})
const piniaStore = useStore()
const { t } = useI18n({ useScope: 'global' })

const props = __props
//Store survey options
const recapStore = storeToRefs(useStoreRecaps())
const recapDefinition = ref<typeof RecapDefinition | null>(null)
const recaps = computed(() =>
  Object.keys(recapStore.recaps.value)
    .map((key) => recapStore.recaps.value[key])
    .filter((recap) => recap.store_id === (props.storeId as string))
)
const surveySelection = ref()
const storeSurveyOptions = ref([
  ...recaps.value.map((recap) => ({ label: recap.recapDefinition!.name, value: recap })),
])
const currentRecapResponse = computed(() =>
  recapStore.recap_responses.value.find(
    (res) =>
      res.events_recaps_id === surveySelection.value.value.recapDefinition.id &&
      res.store_id === (props.storeId as string)
  )
)
const recapSubmittedForCurrentRecap = computed(() => !!currentRecapResponse.value)
watch(recaps, () => {
  storeSurveyOptions.value = recaps.value.map((recap) => ({
    label: recap.recapDefinition!.name,
    value: recap,
  }))
})
function clearStoreRecapSelectionBeforeUpdate(value: any) {
  // Clears the selection of the store recap before performing the final update
  // This is to ensure the new recap loads and stale data isn't present
  // Also, manually clear the forms saved in the useFields component.
  // For some reason, they weren't being cleared properly when swapping between recaps,
  // which caused carryover data between responses
  surveySelection.value = null
  void nextTick(() => {
    ;(recapDefinition.value as any)?.resetRecap()
    void nextTick(() => {
      surveySelection.value = value
    })
  })
}

async function endSurveyAndFetchRecap() {
  if (surveySelection.value) {
    const res = await useStoreRecaps().saveRecap(
      recapDefinition.value,
      props.storeId as string,
      surveySelection.value.value.recapDefinition.id
    )
    if (res === true) {
      const recapSubmittedEvent = new CustomEvent<{ success: boolean }>('recapSubmitted', {
        detail: {
          success: true,
        },
      })
      window.dispatchEvent(recapSubmittedEvent)
    }
  }
}

async function editRecap() {
  if (currentRecapResponse.value) {
    await nextTick().catch(null)
    await nextTick().catch(null)
    const unmodifiedStore = useStoreRecaps()
    await unmodifiedStore.deleteRecapResponse(currentRecapResponse.value as RecapResponse)
  }
}

function refreshStoreRecapAFterSync() {
  if (recapSubmittedForCurrentRecap.value) {
    clearStoreRecapSelectionBeforeUpdate(null)
  }
}

onMounted(() => {
  window.addEventListener('syncStarted', refreshStoreRecapAFterSync)
})
onUnmounted(() => {
  window.removeEventListener('syncStarted', refreshStoreRecapAFterSync)
})

return (_ctx: any,_cache: any) => {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_page = _resolveComponent("q-page")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (storeSurveyOptions.value && storeSurveyOptions.value.length)
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createVNode(_component_q_select, {
          filled: "",
          modelValue: surveySelection.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((surveySelection).value = $event)),
            clearStoreRecapSelectionBeforeUpdate
          ],
          options: storeSurveyOptions.value,
          label: "Select Survey",
          behavior: "menu",
          clearable: ""
        }, null, 8, ["modelValue", "options"]),
        (surveySelection.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createBlock(_Suspense, null, {
                fallback: _withCtx(() => [
                  _createVNode(_component_q_page, { class: "full-width column items-center tw-my-6" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('recap.loadingRecap', 0, { locale: _unref(piniaStore).user.language })), 1)
                    ]),
                    _: 1
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(RecapDefinition, {
                    ref_key: "recapDefinition",
                    ref: recapDefinition,
                    "task-or-store-id": props.storeId,
                    "recap-id": surveySelection.value.value.recapDefinition.id,
                    "recap-type": "store"
                  }, null, 8, ["task-or-store-id", "recap-id"])
                ]),
                _: 1
              })),
              (recapSubmittedForCurrentRecap.value)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    class: "tw--mt-64 q-mx-md",
                    color: 'primary',
                    onClick: editRecap
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('storeItems.update_survey', 0, { locale: _unref(piniaStore).user.language })), 1)
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    class: "tw--mt-64 q-mx-md",
                    onClick: endSurveyAndFetchRecap
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('storeItems.end_survey', 0, { locale: _unref(piniaStore).user.language })), 1)
                    ]),
                    _: 1
                  }))
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}
}

})